import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminReportsButtons = ({
  dataLoading,
  filters,
  handleSubmitView,
  handleSubmitDownload,
  handleSwitchFilters,
}) => {
  const intl = useIntl();

  return (
    <div className="report-buttons-wrapper">
      <Button
        type="button"
        onClick={handleSubmitView}
        disabled={dataLoading}
      >
        {intl.formatMessage({ defaultMessage: 'View' })}
      </Button>
      <Button
        type="button"
        onClick={handleSubmitDownload}
        disabled={dataLoading}
      >
        {intl.formatMessage({ defaultMessage: 'Download' })}
      </Button>
      {filters && (
        <Button
          type="button"
          className="filters-button"
          onClick={handleSwitchFilters}
          disabled={dataLoading}
          title="Filters"
        >
          <i className="far fa-sliders" />
        </Button>
      )}
    </div>
  );
};

AdminReportsButtons.propTypes = {
  dataLoading: PropTypes.bool.isRequired,
  filters: PropTypes.bool.isRequired,
  handleSubmitView: PropTypes.func.isRequired,
  handleSubmitDownload: PropTypes.func.isRequired,
  handleSwitchFilters: PropTypes.func.isRequired,
};

export default AdminReportsButtons;
